import type { WorkflowStage } from '../../types/workflow'
import { getTextVariable } from './template-variable-utils'

interface IntroTemplateProps {
  stage: WorkflowStage
  onContinue: () => void
}

export default function IntroTemplate({ stage, onContinue }: IntroTemplateProps) {
  const bgImageUrl = getTextVariable(stage.templateVariables, 'bg_image_url', '')
  const header = getTextVariable(stage.templateVariables, 'header', 'Before we begin...')
  const subtitle = getTextVariable(stage.templateVariables, 'sub_title', '')
  const paragraph = getTextVariable(stage.templateVariables, 'paragraph', '')
  const buttonText = getTextVariable(stage.templateVariables, 'button_text', "Let's Begin")

  return (
    <div className="flex flex-1 flex-col">
      <div className="mb-6">
        <h1 className="font-secondary text-[38px] leading-tight tracking-tight text-white">{header}</h1>
        {subtitle && <p className="mt-4 whitespace-pre-line text-[16px] font-medium leading-relaxed text-white/80">{subtitle}</p>}
      </div>

      {bgImageUrl && (
        <div className="relative mb-6 min-h-[200px] flex-1 overflow-hidden rounded-[14px]">
          <img src={bgImageUrl} alt="" className="absolute inset-0 h-full w-full object-cover" />
        </div>
      )}

      {paragraph && (
        <p className="mb-5 text-center text-[13px] leading-relaxed text-white/60">
          {paragraph}
        </p>
      )}

      <div className="mb-2">
        <p className="text-sm leading-6 text-white/70">
          This takes about 5 minutes.
        </p>
      </div>
      <div className="mt-auto pb-8">
        <button
          onClick={onContinue}
          className="w-full py-4 px-6 text-[15px] font-semibold text-[var(--ww-btn-text)] bg-[var(--ww-btn-bg)] border-none rounded-full cursor-pointer transition-all duration-300 shadow-[0_2px_8px_rgba(0,0,0,0.1)] hover:bg-[var(--ww-btn-hover)] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.15)] active:translate-y-0"
        >
          {buttonText}
        </button>
      </div>
    </div>
  )
}
